import { SxProps } from '@mui/material';

export const DashboardStyles = {
  container: {
    minHeight: '111.11vh',
    padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
  },
  contentWrapper: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: { xs: '15px', md: '20px' },
    padding: { xs: '1.5rem', md: '2rem' },
    marginBottom: { xs: '1.5rem', md: '2rem' },
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  welcomeText: {
    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' },
    fontWeight: 400,
    background: 'linear-gradient(45deg, #667eea, #764ba2)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '0.5rem',
    textAlign: { xs: 'center', md: 'left' },
  },
  subtitle: {
    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: '1.5rem',
    textAlign: { xs: 'center', md: 'left' },
  },
  statsContainer: {
    display: 'flex',
    gap: { xs: '1rem', sm: '1.5rem', md: '2rem' },
    flexWrap: 'wrap',
    justifyContent: { xs: 'center', md: 'flex-start' },
  },
  statCard: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    color: 'white',
    padding: { xs: '0.8rem 1rem', md: '1rem 1.5rem' },
    borderRadius: '12px',
    minWidth: { xs: '120px', sm: '140px', md: '150px' },
    textAlign: 'center',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  statValue: {
    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' },
    fontWeight: 700,
    marginBottom: '0.25rem',
  },
  statLabel: {
    fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
    opacity: 0.9,
  },
  organsSection: {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: { xs: '15px', md: '20px' },
    padding: { xs: '1.5rem', md: '2rem' },
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  sectionTitle: {
    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' },
    fontWeight: 600,
    color: 'rgb(65, 69, 74)',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  organsGrid: {
    padding: '1rem 0',
  },
  progressOverview: {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: { xs: '15px', md: '20px' },
    padding: { xs: '1.5rem', md: '2rem' },
    marginBottom: { xs: '1.5rem', md: '2rem' },
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  progressTitle: {
    fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.7rem' },
    fontWeight: 600,
    color: 'rgb(65, 69, 74)',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  progressGrid: {
    display: 'grid',
    gridTemplateColumns: { 
      xs: 'repeat(2, 1fr)', 
      sm: 'repeat(3, 1fr)', 
      md: 'repeat(4, 1fr)', 
      lg: 'repeat(6, 1fr)' 
    },
    gap: { xs: '0.8rem', md: '1rem' },
  },
  progressItem: {
    textAlign: 'center',
    padding: { xs: '0.8rem', md: '1rem' },
    borderRadius: '12px',
    background: 'linear-gradient(145deg, #f8f9ff 0%, #ffffff 100%)',
    border: '1px solid rgba(102, 126, 234, 0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.15)',
    },
  },
  progressItemName: {
    fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
    fontWeight: 600,
    color: 'rgb(65, 69, 74)',
    marginBottom: '0.5rem',
  },
  progressItemBar: {
    height: { xs: '6px', md: '8px' },
    borderRadius: '4px',
    backgroundColor: 'rgba(102, 126, 234, 0.15)',
    overflow: 'hidden',
    marginBottom: '0.5rem',
    '& .MuiLinearProgress-bar': {
      background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '4px',
    },
  },
  progressItemValue: {
    fontSize: { xs: '0.7rem', md: '0.75rem' },
    fontWeight: 600,
    color: 'rgb(102, 126, 234)',
  },
} satisfies Record<string, SxProps>;
